import React from "react";
import { render } from "react-dom";
import Gallery from "react-photo-gallery";
import  photos from "./photos";
import Aos from "aos";
import "aos/dist/aos.css";


const Collage=()=>{
    Aos.init({duration:1000})
    return(
        <>
            <div style={{backgroundColor:"#EBEBEB",backgroundSize:"100% 100%",paddingTop:"40px"}}>
            <div className="container" style={{display:"flex",
                alignItems:"center",
                justifyContent:"center",
                flexDirection:"column",
                }}>
                    <center><h2 data-aos="fade-up" style={{fontWeight:"bold",borderBottom:"2px solid #efb1ff",paddingBottom:"20px"}}>OUR GOALS</h2></center><br/>
                    <center><p data-aos="fade-up" style={{fontSize:"18px", fontWeight:"500"}}> Affiliate with women in stem who have accomplished great heights in their career. Inspire young minds to take up leadership roles and stem roles as career. To affiliate with NGO’s and people with similar visions to promote the cause. Help sponsor bright talents through merit based scholarships and jobs. Affiliate with companies and stand against gender based wage gap.</p></center>
                 </div><br/><br/>
            <Gallery photos={photos} />;
            </div>
        </>
    )
}
export default Collage